<template>
  <div class="content">
    <img
      v-for="i in imgNum"
      :key="'bc-' + i"
      :src="getImg(i)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return { 
      imgHead: 'score',
      imgNum: 6
    }
  },
  created() {
    switch (this.$route.query.imgType) {
      case 'exposure': {
        this.imgHead = 'exposure'
        this.imgNum = 4
        break
      }
    }
  },
  methods: {
    getImg(i) {
      const middle = this.$util.nativeType ? 'mobile' : 'pc'
      return require(`@/assets/image/background/${this.imgHead}-${middle}-${i}.png`)
    }
  },
}
</script>

<style lang="scss" scoped>
  .content {
    font-size: 0;
    >img {
      width: 100%;
      user-select: none;
      -webkit-user-select: none;
    }
  }
  @media screen and (min-width: 600px) {
    .content {
      width: 1200px;
      margin: 0 auto;
    }
  }
</style>